import type { MultipleSelectClient } from '@/company-portal/add-file/add-file.types';
import type { useClientSendWireInstructionsStepper } from '@/components/Views/Clients/WireInstructions/useClientSendWireInstructionsStepper';
import type {
    SendWireInstructionsBranch,
    SendWireInstructionsCompany,
    SendWireInstructionsFile,
    SendWireInstructionsRoutes,
} from '@/stores/client/send-wire/client-send-wire-instructions.types';
import { type InjectionKey, type Ref } from 'vue';

interface FileDetailsSheetInjectionKey {
    isSheetOpen: Ref<boolean>;
    openSheet: () => void;
    closeSheet: () => void;
}

interface EditAvailableClientSheetInjectionKey {
    editAvailable: boolean;
    openEditClientSheet: (clientValue: MultipleSelectClient['value']) => void;
}

interface EsignInvalidationDialogInjectionKey {
    openEsignInvalidationDialog: () => void;
    closeEsignInvalidationDialog: () => void;
}

export const CSRF_TOKEN_INJECTION_KEY: InjectionKey<string> = Symbol('csrf_token');
export const NO_SIDEBAR_ROUTES_INJECTION_KEY: InjectionKey<string[]> = Symbol('no_sidebar_routes');
export const INTEGRATION_ROUTES_INJECTION_KEY: InjectionKey<string[]> = Symbol('integration_routes');
export const REQUEST_WIRE_INFORMATION_SHEET_INJECTION_KEY: InjectionKey<FileDetailsSheetInjectionKey> =
    Symbol('request_wire_information_sheet');
export const IDV_SHEET_INJECTION_KEY: InjectionKey<FileDetailsSheetInjectionKey> = Symbol('idv_sheet');
export const REQUEST_DOCUMENT_SHEET_INJECTION_KEY: InjectionKey<FileDetailsSheetInjectionKey> = Symbol('request_document_sheet');
export const SEND_WIRE_DOC_SHEET_INJECTION_KEY: InjectionKey<FileDetailsSheetInjectionKey> = Symbol('send_wire_doc_sheet');
export const SEND_DOCUMENT_SHEET_INJECTION_KEY: InjectionKey<FileDetailsSheetInjectionKey> = Symbol('send_document_sheet');
export const EDIT_AVAILABLE_CLIENT_SHEET_INJECTION_KEY: InjectionKey<EditAvailableClientSheetInjectionKey> =
    Symbol('edit_available_client_sheet');
export const ESIGN_INVALIDATION_DIALOG_INJECTION_KEY: InjectionKey<EsignInvalidationDialogInjectionKey> =
    Symbol('esign_invalidation_dialog');

export const FILE_INJECTION_KEY: InjectionKey<SendWireInstructionsFile> = Symbol('send_wire_instructions_file');
export const BRANCH_INJECTION_KEY: InjectionKey<SendWireInstructionsBranch> = Symbol('send_wire_instructions_branch');
export const COMPANY_INJECTION_KEY: InjectionKey<SendWireInstructionsCompany> = Symbol('send_wire_instructions_company');
export const ROUTES_INJECTION_KEY: InjectionKey<SendWireInstructionsRoutes> = Symbol('send_wire_instructions_routes');
export const ROUTING_NUMBER_VALIDATION_RELAXED_INJECTION_KEY: InjectionKey<boolean> = Symbol('routing_number_validation_relaxed');
export const STEPPER_INJECTION_KEY: InjectionKey<ReturnType<typeof useClientSendWireInstructionsStepper>> = Symbol('stepper');
